import React from "react";

/**
 * Glyphs shared across the builder cards.
 *
 * These lived as private copies inside RxPickerCard and AdvisedInvestigationsCard
 * and drifted apart — the picker's × ended up 8px/1.4 against the investigation
 * row's 10px/1.6, which reads as two different controls on one screen. One
 * definition is the only thing that keeps them honest.
 */

/** Figma's 10px plain × — two strokes, no ring, no background. */
export const Close = () => (
  <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M2.6 2.6l6.8 6.8M9.4 2.6l-6.8 6.8" strokeLinecap="round" />
  </svg>
);

/** Card collapse caret — points up while open, CSS flips it when collapsed. */
export const Chevron = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M12 10L8 6l-4 4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
